/* eslint-disable @typescript-eslint/no-explicit-any */
// function escapeValueString(str: string): string {
//   return str
//     .replace(/\\/g, '\\\\')
//     .replace(/“/g, "'")
//     .replace(/\|/g, '\\|')
//     .replace(/~/g, '\\~');
// }

export function escapeJsonValues<T>(input: T, excludeKeys: string[] = []): T {
  // if (typeof input === 'string') {
  //   return escapeValueString(input) as unknown as T;
  // }

  if (Array.isArray(input)) {
    return input.map((item) =>
      escapeJsonValues(item, excludeKeys)
    ) as unknown as T;
  }

  if (input !== null && typeof input === 'object') {
    const result: Record<string, any> = {};

    for (const key of Object.keys(input)) {
      const value = (input as Record<string, any>)[key];

      if (excludeKeys.includes(key)) {
        result[key] = value;
        continue;
      }

      result[key] = escapeJsonValues(value, excludeKeys);
    }

    return result as T;
  }

  return input;
}
